import React from "react";
import { Button } from "@/components/ui/button";

interface ColumnActionsProps {
  onShowAll: () => void;
  onHideAll: () => void;
  onReset: () => void;
}

export function ColumnActions({ onShowAll, onHideAll, onReset }: ColumnActionsProps) {
  return (
    <div className="flex gap-2">
      <Button variant="outline" size="sm" onClick={onShowAll} aria-label="Show all columns">
        Show all
      </Button>
      <Button variant="outline" size="sm" onClick={onHideAll} aria-label="Hide all columns">
        Hide all
      </Button>
      <Button variant="outline" size="sm" onClick={onReset} aria-label="Reset columns">
        Reset
      </Button>
    </div>
  );
}
